module.exports = __webpack_public_path__ + "static/media/areas06.203eb064.jpg";